import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store/index.js'
import {getUserLogin} from '@/script/apiService/api.js'

let root = process.env.VUE_APP_PACACLOUND_ROOT;

Vue.use(VueRouter);

const routes = [
  {
    path: `${root}`,
    name: "Home",
    redirect: { name: 'AdminSummary' }
  },
  {
    path: `${root}/public/terms`,
    name: "Terms",
    component: () => {
      return import("@/view/public/terms.vue")
    }
  },
  {
    path: `${root}/public/privacy`,
    name: "Privacy",
    component: () => {
      return import("@/view/public/privacy.vue")
    }
  },
  {
    path: `${root}/login`,
    name: "Login",
    redirect: { name: 'Production' }
  },
  {
    path: `${root}/login/production`,
    name: "Production",
    component: () => {
      return import("@/view/login/production.vue")
    }
  },
  {
    path: `${root}/service/summary`,
    name: "ServiceSummary",
    component: () => {
      return import("@/view/service/summary.vue")
    }
  },
  {
    path: `${root}/service/site`,
    name: "UserSite",
    component: () => {
      return import("@/view/service/site.vue")
    }
  },
  {
    path: `${root}/service/apiToken`,
    name: "UserToken",
    component: () => {
      return import("@/view/service/token.vue")
    }
  },
  {
    path: `${root}/report/ntpReport`,
    name: "NtpReport",
    component: () => {
      return import("@/view/report/ntpReport.vue")
    }
  },
  {
    path: `${root}/adminArea/agent`,
    name: "Agent",
    component: () => {
      return import("@/view/adminArea/agent.vue")
    }
  },
  {
    path: `${root}/adminArea/reg`,
    name: "Reg",
    component: () => {
      return import("@/view/adminArea/reg.vue")
    }
  },
  {
    path: `${root}/adminArea/regList`,
    name: "RegList",
    component: () => {
      return import("@/view/adminArea/regList.vue")
    }
  },
  {
    path: `${root}/adminArea/history`,
    name: "History",
    component: () => {
      return import("@/view/adminArea/history.vue")
    }
  },
  {
    path: `${root}/adminArea/siteOwner`,
    name: "SiteOwner",
    component: () => {
      return import("@/view/adminArea/siteOwner.vue")
    }
  },
  {
    path: `${root}/adminArea/token`,
    name: "Token",
    component: () => {
      return import("@/view/adminArea/token.vue")
    }
  },
  {
    path: `${root}/adminArea/user`,
    name: "User",
    component: () => {
      return import("@/view/adminArea/user.vue")
    }
  },
  {
    path: `${root}/adminArea/form`,
    name: "Form",
    component: () => {
      return import("@/view/adminArea/form.vue")
    }
  },
  {
    path: `${root}/adminArea/summary`,
    name: "AdminSummary",
    component: () => {
      return import("@/view/adminArea/summary.vue")
    }
  },
  {
    path: `${root}/adminArea/serviceList`,
    name: "ServiceList",
    component: () => {
      return import("@/view/adminArea/serviceList.vue")
    }
  },
  {
    path: `${root}/adminArea/complex`,
    name: "Complex",
    component: () => {
      return import("@/view/adminArea/complex.vue")
    }
  },
  {
    path: `${root}/adminArea/form`,
    name: "AdminForm",
    component: () => {
      return import("@/view/adminArea/form.vue")
    }
  },
  {
    path: `${root}/dataSearch`,
    name: "DataSearch",
    component: () => {
      return import("@/view/dataSearch/dataSearch.vue")
    }
  },
  {
    path: `${root}/resetNickname`,
    name: "ResetNickname",
    component: () => {
      return import("@/view/account/resetNickname.vue")
    }
  },
  {
    path: `${root}/resetPassword`,
    name: "ResetPassword",
    component: () => {
      return import("@/view/account/resetPassword.vue")
    }
  },
  // {
  //   path: `${root}*`,
  //   redirect: {name: 'Home'}
  // }
]
const router = new VueRouter({
  mode: 'history',
  routes
})
let checkTokenTimeOnce = async function(){
  let res = await getUserLogin();
  if(!res.error_status){
    if(res.is_partner == 1){
      store.commit({
        type: "setUserInfo",
        userInfo: null
      })
      return false;
    }
  }
  checkTokenTimeOnce = function(){};
}
router.beforeEach(async (to,from,next) => {
  if(window.innerWidth < 769){
    store.commit({
      type: 'setAsideCollapseButton',
      isOpen: false
    })
  }
  if(to.path == `${root}/public/terms` || to.path == `${root}/public/privacy`){
    next();
  }else{
    if(to.path != `${root}/logout` && store.state.userInfo){
      await checkTokenTimeOnce();
    }
    if(to.path.indexOf(`${root}/login`) == -1 && !store.state.userInfo){
      next(`${root}/login`);
    }else if(to.path.indexOf(`${root}/login`) != -1 && !store.state.userInfo){
      next();
    }else if(to.path.indexOf(`${root}/login`) != -1 && store.state.userInfo){
      next(from);
    }else{
      next();
    }
  }
})

export default router;
